<div class="w-full h-full DealerInfoComponent-revolution ef-scrollbar">
  @if (!showWorkingHours) {
    <span class="heading-small block">
      <T
      str="Your dealer"
      key="customerPortal.customer-portal.top-bar.appointments.upcoming.yourdealer"
      tags="customer-portal, 3.1"
    ></T>
  </span>
}
<div class="relative">
  @if (showMap && lat && lng) {
    <customer-portal-agm-map
      #map
      [zoom]="zoom"
      [longitude]="lng"
      [latitude]="lat"
      [markDraggable]="false"
      [height]="'240px'"
      class="h-[240px]"
      >
    </customer-portal-agm-map>
  }
</div>
<div
  class="pt-5 grid grid-cols-1 md:grid-cols-2 font-normal text-sm overflow-auto max-h-[calc(100%_-_240px)] gap-0"
  >
  @if (showWorkingHours) {
    <div>
      <div class="uppercase font-bold">
        <T
        str="Place"
        key="customerPortal.customer-portal.dealer-details.location"
        tags="customer-portal, 3.1"
      ></T>
    </div>
    <div class="inline-flex">
      <mat-icon class="align-middle mr-2.5" svgIcon="location_on"></mat-icon>
      <p class="mb-4 text-mat-ef-primary-500">
        {{ dealer.street ? dealer.street : '' }},
        {{ dealer.zip ? dealer.zip : '' }}
        {{ dealer.city ? dealer.city : '' }}
      </p>
    </div>
    <ng-container>
      <button
        mat-button
        mat-flat-button
        color="secondary"
        class="revolution w-full md:w-fit text-base h-12 px-8 mt-6"
        (click)="showDirection()"
        >
        <mat-icon
          svgIcon="directions"
          class="align-middle mr-2.5 text-xl"
        ></mat-icon>
        <ng-container *ngTemplateOutlet="directions"></ng-container>
      </button>
    </ng-container>
  </div>
}
@if (!showWorkingHours) {
  <div>
    <div class="location">
      <mat-icon class="primary" svgIcon="location_on"></mat-icon>
      <p>
        {{ dealer.name }}{{ dealer.subname ? ', ' + dealer.subname : '' }}
      </p>
    </div>
    <div class="text-black">
      <span
        >{{ dealer.street ? dealer.street : '' }},
        {{ dealer.zip ? dealer.zip : '' }}
        {{ dealer.city ? dealer.city : '' }}
      </span>
    </div>
    <button
      class="mt"
      mat-button
      mat-flat-button
      color="primary"
      (click)="showDirection(); sendOutboundLinkData('Routefinder', dealer)"
      >
      <mat-icon svgIcon="directions"></mat-icon>
      <ng-container *ngTemplateOutlet="directions"></ng-container>
    </button>
  </div>
}
<div class="data-contact">
  @if (showWorkingHours) {
    <div class="uppercase font-bold">
      {{ 'contact' | sharedTranslate }}
    </div>
  }
  <p
    class="mb-2 text-mat-ef-primary-500"
    (click)="sendOutboundLinkData('Phone click', dealer)"
    >
    <mat-icon class="align-middle mr-2.5" svgIcon="phone"></mat-icon
      ><a href="tel:{{ dealer.telephone }}" data-rel="external">{{
      dealer.telephone
    }}</a>
  </p>
  <p
    class="mb-2 text-mat-ef-primary-500"
    (click)="sendOutboundLinkData('Email click', dealer)"
    >
    <mat-icon class="align-middle mr-2.5" svgIcon="email"></mat-icon>
    <a href="mailto:{{ dealer.email }}" data-rel="external">{{
      dealer.email
    }}</a>
  </p>
  @if (showOpeningTimeInContact) {
    <div class="data-hours">
      @if (
        dealer &&
        dealer.openingHours &&
        dealer.openingHours.service.length > 0
        ) {
        <div
          class="flex my-[14px]"
          >
          @if (openServices) {
            <div class="ml-1">
              <div
                class="float-left w-2.5 h-2.5 m-[5px] rounded-md bg-mat-ef-green-secondary-500 p-0.5"
              ></div>
              <span
                ><ng-container *ngTemplateOutlet="nowOpen"></ng-container>
                @if (serviceWorkingHours.day) {
                  (
                  <ng-container
                  *ngTemplateOutlet="
                    dayTranslation;
                    context: { day: serviceWorkingHours.day }
                  "
                  ></ng-container>
                }
                {{ serviceWorkingHours.dateToday + ' )' }}</span
                >
              </div>
            }
            @if (!openServices) {
              <div class="ml-1">
                <div
                  class="float-left w-2.5 h-2.5 m-[5px] rounded-md bg-red-500 p-0.5"
                ></div>
                <span>
                  <ng-container *ngTemplateOutlet="nowClosed"></ng-container>
                  @if (day) {
                    (
                    <ng-container
                      *ngTemplateOutlet="dayTranslation; context: { day: day }"
                    ></ng-container>
                  }
                  {{
                  serviceWorkingHours.dateToday
                  ? serviceWorkingHours.dateToday + ' )'
                  : '
                  -)'
                  }}
                </span>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
  @if (showWorkingHours) {
    <div class="data-hours">
      @if (
        dealer && dealer.openingHours && dealer.openingHours.sales.length > 0
        ) {
        <div
          class="flex my-[14px]"
          >
          <div class="uppercase font-bold">
            {{ 'sale' | sharedTranslate }}
          </div>
          @if (openSales) {
            <div class="ml-1">
              <div
                class="float-left w-2.5 h-2.5 m-[5px] rounded-md bg-mat-ef-green-secondary-500 p-0.5"
              ></div>
              <span>
                <ng-container *ngTemplateOutlet="nowOpen"></ng-container
                ></span>
              </div>
            }
            @if (!openSales) {
              <div class="ml-1">
                <div
                  class="float-left w-2.5 h-2.5 m-[5px] rounded-md bg-red-500 p-0.5"
                ></div>
                <span
                  ><ng-container *ngTemplateOutlet="nowClosed"></ng-container
                ></span>
              </div>
            }
          </div>
        }
        @if (
          dealer && dealer.openingHours && dealer.openingHours.sales.length > 0
          ) {
          <div
            class="inline-flex"
            >
            <mat-icon class="w-[32px]" svgIcon="watch_later"></mat-icon>
            <div class="w-auto">
              @for (day of workingDaysSales; track day) {
                <div
                  class="grid grid-cols-hours-grid"
                  [ngClass]="{ hidden: day.hours.length === 0 }"
                  >
                  @if (day.hours.length === 1 && day.hours[0] !== '') {
                    <p
                      class="p-0"
                      >
                      <ng-container
                        *ngTemplateOutlet="dayTranslation; context: { day: day.day }"
                        ></ng-container
                        >:
                      </p>
                    }
                    @if (day.hours.length === 1 && day.hours[0] !== '') {
                      <div>
                        {{ day.hours[0] }}
                        <ng-container *ngTemplateOutlet="time"></ng-container>
                      </div>
                    }
                    @if (
                      day.hours.length > 1 &&
                      day.hours[0] !== '' &&
                      day.hours[1] !== ''
                      ) {
                      <p
                        class="p-0"
                        >
                        <ng-container
                          *ngTemplateOutlet="dayTranslation; context: { day: day.day }"
                        ></ng-container>
                        :
                      </p>
                    }
                    @if (
                      day.hours.length > 1 &&
                      day.hours[0] !== '' &&
                      day.hours[1] !== ''
                      ) {
                      <div
                        >
                        {{ day.hours[0] }}
                        <ng-container *ngTemplateOutlet="time"></ng-container>
                      </div>
                    }
                    <div></div>
                    @if (
                      day.hours.length > 1 &&
                      day.hours[0] !== '' &&
                      day.hours[1] !== ''
                      ) {
                      <div
                        >
                        {{ day.hours[1] }}
                        <ng-container *ngTemplateOutlet="time"></ng-container>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      @if (showWorkingHours) {
        <div class="data-hours">
          @if (
            dealer &&
            dealer.openingHours &&
            dealer.openingHours.service.length > 0
            ) {
            <div
              class="flex my-[14px]"
              >
              <div class="uppercase font-bold">
                {{ 'service' | sharedTranslate }}
              </div>
              @if (openServices) {
                <div class="ml-1">
                  <div
                    class="float-left w-2.5 h-2.5 m-[5px] rounded-md bg-mat-ef-green-secondary-500 p-0.5"
                  ></div>
                  <span>
                    <ng-container *ngTemplateOutlet="nowOpen"></ng-container
                    ></span>
                  </div>
                }
                @if (!openServices) {
                  <div class="ml-1">
                    <div
                      class="float-left w-2.5 h-2.5 m-[5px] rounded-md bg-red-500 p-0.5"
                    ></div>
                    <span>
                      <ng-container *ngTemplateOutlet="nowClosed"></ng-container
                      ></span>
                    </div>
                  }
                </div>
              }
              @if (
                dealer &&
                dealer.openingHours &&
                dealer.openingHours.service.length > 0
                ) {
                <div
                  class="inline-flex"
                  >
                  <mat-icon class="w-[32px]" svgIcon="watch_later"></mat-icon>
                  <div class="w-auto">
                    @for (day of workingDaysService; track day) {
                      <div
                        class="grid grid-cols-hours-grid"
                        [ngClass]="{ hidden: day.hours.length === 0 }"
                        >
                        @if (day.hours.length === 1 && day.hours[0] !== '') {
                          <p>
                            <ng-container
                              *ngTemplateOutlet="dayTranslation; context: { day: day.day }"
                            ></ng-container>
                            :
                          </p>
                        }
                        @if (day.hours.length === 1 && day.hours[0] !== '') {
                          <div>
                            {{ day.hours[0] }}
                            <ng-container *ngTemplateOutlet="time"></ng-container>
                          </div>
                        }
                        @if (day.hours.length > 1) {
                          <p>
                            <ng-container
                              *ngTemplateOutlet="dayTranslation; context: { day: day.day }"
                              ></ng-container
                              >:
                            </p>
                          }
                          @if (day.hours.length > 1) {
                            <div>
                              {{ day.hours[0] }}
                              <ng-container *ngTemplateOutlet="time"></ng-container>
                            </div>
                          }
                          <div></div>
                          @if (day.hours.length > 1) {
                            <div>
                              {{ day.hours[1] }}
                              <ng-container *ngTemplateOutlet="time"></ng-container>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>

        <ng-template #time>
          <T
          str="Clock"
          key="customerPortal.customer-portal.dealers.time"
          tags="customer-portal, 3.1"
        ></T>
      </ng-template>

      <ng-template #nowClosed>
        <T
        str="Now closed"
        key="customerPortal.customer-portal.vehicle.nowClosed"
        tags="customer-portal, 3.1"
      ></T>
    </ng-template>

    <ng-template #nowOpen>
      <T
      str="Now open"
      key="customerPortal.customer-portal.vehicle.nowOpen"
      tags="customer-portal, 3.1"
    ></T>
  </ng-template>

  <ng-template #directions>
    <T
    str="Directions"
    key="customerPortal.customer-portal.dealer-details.directions"
    tags="customer-portal, 3.1"
  ></T>
</ng-template>

<ng-template #dayTranslation let-day="day">
  <ng-container
    *ngTemplateOutlet="
      sharedService.template('transifexTranslation');
      context: {
        str: day,
        prefix: 'customerPortal.customer-portal.dealer-details.days.'
      }
    "
></ng-container>
</ng-template>
